import { useState } from "react"

import "~/components/Label/Label"
import "./Checkbox.scss"
import Label from "~/components/Label/Label"

export type CheckboxProps = {
  id: string
  label?: string
  value: boolean
  valueChanged?: (newValue: boolean) => void
}

function Checkbox(props: CheckboxProps) {
  const [value, setValue] = useState(props.value)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.checked)

    if (props.valueChanged) {
      props.valueChanged(event.target.checked)
    }
  }

  const { id, label } = props

  return (
    <div>
      {label && <Label className="Checkbox__label-text" text={label} />}

      <div className="Checkbox__switch">
        <input
          type="checkbox"
          id={id}
          className="Checkbox__switch-input"
          value={String(value)}
          checked={value}
          onChange={handleChange}
        />
        <label htmlFor={id} className="Checkbox__switch-label"></label>
      </div>
    </div>
  )
}

export default Checkbox
